import { render, staticRenderFns } from "./BalanceDepositAccount.vue?vue&type=template&id=3cdb8480&scoped=true&"
import script from "./BalanceDepositAccount.vue?vue&type=script&lang=js&"
export * from "./BalanceDepositAccount.vue?vue&type=script&lang=js&"
import style0 from "./BalanceDepositAccount.vue?vue&type=style&index=0&id=3cdb8480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdb8480",
  null
  
)

export default component.exports